
//For Policy statement headings
document.addEventListener('DOMContentLoaded', () => {
  const title = document.querySelector('.shopify-policy__title');
  const body = document.querySelector('.shopify-policy__body');
  if (!title) return;

  // Walk through all text nodes and wrap each word in a span
  const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT, null);
  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach(node => {
    const words = node.textContent.split(/(\s+)/);
    const fragment = document.createDocumentFragment();

    words.forEach(word => {
      if (word.match(/\s+/)) {
        fragment.appendChild(document.createTextNode(word));
      } else if (word.length > 0) {
        const span = document.createElement('span');
        span.className = 'policy-title-word';
        span.style.display = 'inline-block';
        span.style.opacity = '0';
        span.textContent = word;
        fragment.appendChild(span);
      }
    });

    node.parentNode.replaceChild(fragment, node);
  });

  const wordEls = title.querySelectorAll('.policy-title-word');

  gsap.set(wordEls, { opacity: 0 });
  if (body) gsap.set(body, { opacity: 0 });

  const tl = gsap.timeline({ delay: 0.2 });

  tl.to(wordEls, {
    opacity: 1,
    duration: 0.5,
    ease: 'power2.out',
    stagger: 0.5
  });

  if (body) {
    tl.to(body, {
      opacity: 1,
      duration: 1,
      ease: 'power2.out'
    });
  }
});